import Layout from '@/layout/default'

const commonRouter = {
    path: '/replace', // 刷新页面
    name: 'replace',
    component: Layout,
    children: [
        {    
            path: '/',
            meta: {
                title: '刷新中'
            },
            component: () => import('@/views/project_manage/index/replace.vue')
        }
    ]
}

export default commonRouter;
